__webpack_require__.p = "./wp-content/react-reading-app/";